export function identifyUser(email) {
  if (process.env.NODE_ENV === "production") {
    window.ga("set", "userId", email)
    window.ga("send", "pageview")
  }
}
